module.exports = __webpack_public_path__ + "img/img-team-doctors.7c19817.png";